module.exports = __webpack_public_path__ + "img/KYD.c89f82a1.svg";